import { RoutesManager } from '../shared/models/routes.interfaces';

export function isCollaborationRoute(): boolean {
  return location.pathname.startsWith(`/${RoutesManager.collaboration}/`)
    || location.pathname.startsWith(`/${RoutesManager.collaborationAuthProxy}`);
}